// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nd1f","rootNoMargin":"styles_rootNoMargin__pyNz2"};